<app-header></app-header>

<section class="skills my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-7">
                <h1 class="mb-3 link-primary">
                    Thank you for<br />
                    booking a call!
                </h1>
            </div>

            <div class="col-lg-5">
                We look forward to meeting you. Should you have any<br />
                additional information needed - please don't hestitate<br />
                to get in touch with us via WhatsApp at the link below.<br />
                <br />
                Alternatively, for you can pop us an email:
                <br />
                <br />
                <h4 class="link-primary">Gauteng Enquiries</h4>
                Kwanele<br />
                T. 071 402 1338<br />
                E. kwanele&#64;parkupp.co.za
                <br />
                <br />
                <h4 class="link-primary">Cape Town and Durban Enquiries</h4>
                Umar<br />
                T. 071 280 2308<br />
                E. umar&#64;parkupp.co.za<br />
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
